import { CountryData } from '@/types/CountryData'
import countries from './countriesV2.json'

export const getCountries = (): CountryData[] => {
  return countries.map((country: any) => {
    const name: string = country?.name || ''
    const alpha3Code: string = country?.alpha3Code || ''
    const currencies: string[] =
      country?.currencies.map((currency: any) => currency?.code || '') || []

    return { name, alpha3Code, currencies } as CountryData
  })
}
